module.exports = __webpack_public_path__ + "img/hr-stack-inserter-hand-closed.91348bb5.png";